import React from 'react';
import { RouterProvider } from 'react-router-dom';
import LogRocket from 'logrocket';
import moment from 'moment';

// Setup
const logrocketAppId = import.meta.env.VITE_LOG_ROCKET_APP_ID;
if (logrocketAppId) LogRocket.init(logrocketAppId);

moment().local(true);

// Error Handling
import './services/error-handler.service';

// Infrastructure
import { createRouter } from './_router';
import { useServerVersionRegulator } from './components/domains/settings/settings.utils';

const router = createRouter();

export const RootComponent = () => {
  useServerVersionRegulator();

  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
};
